import Axios from 'axios';
import Cookies from 'js-cookie';

const url = () =>{
    return "https://meatgrades.click:3001/"
}

const CountriesAPI = Axios.create({
    baseURL:url()
});

export default CountriesAPI;